import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './foreigner-residence.reducer';

export const ForeignerResidenceDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const foreignerResidenceEntity = useAppSelector(state => state.foreignerResidence.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="foreignerResidenceDetailsHeading">
          <Translate contentKey="foreignerResidenceApp.foreignerResidence.detail.title">ForeignerResidence</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{foreignerResidenceEntity.id}</dd>
          <dt>
            <span id="recordNumber">
              <Translate contentKey="foreignerResidenceApp.foreignerResidence.recordNumber">Record Number</Translate>
            </span>
          </dt>
          <dd>{foreignerResidenceEntity.recordNumber}</dd>
          <dt>
            <span id="createDate">
              <Translate contentKey="foreignerResidenceApp.foreignerResidence.createDate">Create Date</Translate>
            </span>
          </dt>
          <dd>
            {foreignerResidenceEntity.createDate ? (
              <TextFormat value={foreignerResidenceEntity.createDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="recordDate">
              <Translate contentKey="foreignerResidenceApp.foreignerResidence.recordDate">Record Date</Translate>
            </span>
          </dt>
          <dd>
            {foreignerResidenceEntity.recordDate ? (
              <TextFormat value={foreignerResidenceEntity.recordDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="recordLocation">
              <Translate contentKey="foreignerResidenceApp.foreignerResidence.recordLocation">Record Location</Translate>
            </span>
          </dt>
          <dd>{foreignerResidenceEntity.recordLocation}</dd>
          <dt>
            <span id="foreignerTitle">
              <Translate contentKey="foreignerResidenceApp.foreignerResidence.foreignerTitle">Foreigner Title</Translate>
            </span>
          </dt>
          <dd>{foreignerResidenceEntity.foreignerTitle}</dd>
          <dt>
            <span id="foreignerFullName">
              <Translate contentKey="foreignerResidenceApp.foreignerResidence.foreignerFullName">Foreigner Full Name</Translate>
            </span>
          </dt>
          <dd>{foreignerResidenceEntity.foreignerFullName}</dd>
          <dt>
            <span id="nationality">
              <Translate contentKey="foreignerResidenceApp.foreignerResidence.nationality">Nationality</Translate>
            </span>
          </dt>
          <dd>{foreignerResidenceEntity.nationality}</dd>
          <dt>
            <span id="foreignerPassportNo">
              <Translate contentKey="foreignerResidenceApp.foreignerResidence.foreignerPassportNo">Foreigner Passport No</Translate>
            </span>
          </dt>
          <dd>{foreignerResidenceEntity.foreignerPassportNo}</dd>
          <dt>
            <span id="houseNo">
              <Translate contentKey="foreignerResidenceApp.foreignerResidence.houseNo">House No</Translate>
            </span>
          </dt>
          <dd>{foreignerResidenceEntity.houseNo}</dd>
          <dt>
            <span id="moo">
              <Translate contentKey="foreignerResidenceApp.foreignerResidence.moo">Moo</Translate>
            </span>
          </dt>
          <dd>{foreignerResidenceEntity.moo}</dd>
          <dt>
            <span id="district">
              <Translate contentKey="foreignerResidenceApp.foreignerResidence.district">District</Translate>
            </span>
          </dt>
          <dd>{foreignerResidenceEntity.district}</dd>
          <dt>
            <span id="city">
              <Translate contentKey="foreignerResidenceApp.foreignerResidence.city">City</Translate>
            </span>
          </dt>
          <dd>{foreignerResidenceEntity.city}</dd>
          <dt>
            <span id="province">
              <Translate contentKey="foreignerResidenceApp.foreignerResidence.province">Province</Translate>
            </span>
          </dt>
          <dd>{foreignerResidenceEntity.province}</dd>
          <dt>
            <span id="condition37">
              <Translate contentKey="foreignerResidenceApp.foreignerResidence.condition37">Condition 37</Translate>
            </span>
          </dt>
          <dd>{foreignerResidenceEntity.condition37 ? 'true' : 'false'}</dd>
          <dt>
            <span id="condition38">
              <Translate contentKey="foreignerResidenceApp.foreignerResidence.condition38">Condition 38</Translate>
            </span>
          </dt>
          <dd>{foreignerResidenceEntity.condition38 ? 'true' : 'false'}</dd>
          <dt>
            <span id="purpose">
              <Translate contentKey="foreignerResidenceApp.foreignerResidence.purpose">Purpose</Translate>
            </span>
          </dt>
          <dd>{foreignerResidenceEntity.purpose}</dd>
          <dt>
            <span id="purposeOther">
              <Translate contentKey="foreignerResidenceApp.foreignerResidence.purposeOther">Purpose Other</Translate>
            </span>
          </dt>
          <dd>{foreignerResidenceEntity.purposeOther}</dd>
          <dt>
            <Translate contentKey="foreignerResidenceApp.foreignerResidence.officer">Officer</Translate>
          </dt>
          <dd>{foreignerResidenceEntity.officer ? foreignerResidenceEntity.officer.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/foreigner-residence" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/foreigner-residence/${foreignerResidenceEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ForeignerResidenceDetail;
